import React from "react";
import "./homeProjects.css";
import OurProjects from "../../screens/ourProjects/OurProjects";
import {
  abia_four,
  abia_one,
  abia_three,
  abia_two,
  agege_one,
  agege_two,
  iju_eight,
  iju_eleven,
  iju_five,
  iju_four,
  iju_nine,
  iju_one,
  iju_seven,
  iju_six,
  iju_ten,
  iju_three,
  iju_two,
  ikd_eight,
  ikd_eleven,
  ikd_five,
  ikd_four,
  ikd_nine,
  ikd_one,
  ikd_seven,
  ikd_six,
  ikd_ten,
  ikd_three,
  ikd_twelve,
  ikd_two,
  laspotech_eight,
  laspotech_five,
  laspotech_four,
  laspotech_one,
  laspotech_seven,
  laspotech_six,
  laspotech_three,
  laspotech_two,
  secondary_eight,
  secondary_five,
  secondary_four,
  secondary_nine,
  secondary_one,
  secondary_seven,
  secondary_six,
  secondary_ten,
  secondary_three,
  secondary_two,
  women_eight,
  women_five,
  women_four,
  women_one,
  women_seven,
  women_six,
  women_three,
  women_two,
  youth_eight,
  youth_five,
  youth_four,
  youth_one,
  youth_three,
  youth_two,
} from "../../assets";
import { useNavigate } from "react-router-dom";

const imagesPrint = [
  laspotech_two,
  laspotech_five,
  laspotech_eight,

  laspotech_four,
  laspotech_one,
  laspotech_seven,
  laspotech_six,
  laspotech_three,
];

const secondaryPrint = [
  secondary_seven,
  secondary_six,
  secondary_eight,
  secondary_five,
  secondary_four,

  secondary_one,

  secondary_ten,
  secondary_three,
  secondary_two,
];

const youthPrint = [
  youth_eight,
  youth_five,
  youth_four,
  youth_one,
  youth_three,

  youth_two,
];

const womenPrint = [
  women_eight,
  women_five,
  women_four,
  women_one,
  women_seven,

  women_six,
  women_three,
  women_two,
];

const ijuPrint = [
  iju_six,
  iju_ten,
  iju_three,
  iju_eight,
  iju_eleven,
  iju_five,
  iju_four,
  iju_nine,

  iju_one,
  iju_seven,

  iju_two,
];

const ikdPrint = [
  ikd_eight,
  ikd_eleven,
  ikd_five,
  ikd_four,
  ikd_nine,
  ikd_one,
  ikd_seven,
  ikd_six,
  ikd_ten,
  ikd_three,
  ikd_twelve,
  ikd_two,
];

const agegePrint = [agege_one, agege_two];

const abiaPrint = [abia_one, abia_three, abia_two, abia_four];

const HomeProjects = () => {
  const navigate = useNavigate();

  return (
    <div className="home_projects_body">
      <div className="home_project_section_headinggg">
        Our lectures in various schools
      </div>
      <OurProjects
        imageFiles={imagesPrint}
        projectHeading="Lagos State University of Science and Technology"
      />
      <OurProjects
        imageFiles={secondaryPrint}
        projectHeading="Various Secondary Schools -Interstate"
      />

      <div className="home_project_section_headinggg">Empowerment Program</div>

      <OurProjects
        imageFiles={womenPrint}
        projectHeading="Widows & Women Empowerment"
      />

      <OurProjects
        imageFiles={youthPrint}
        projectHeading="Youth Empowerment (Vocational Programme)"
      />

      <div className="home_project_section_headinggg">Regional Chapters</div>
      <OurProjects
        imageFiles={ijuPrint}
        projectHeading="Iju Ishaga, Lagos Chapter"
      />
      <OurProjects
        imageFiles={agegePrint}
        projectHeading="Agege, Lagos Chapter"
      />
      <OurProjects
        imageFiles={ikdPrint}
        projectHeading="Ikorodu, Lagos Chapter"
      />
      <OurProjects imageFiles={abiaPrint} projectHeading="Abia State Chapter" />

      <div
        onClick={() => {
          navigate("/projects");
        }}
        className="products_famGen"
      >
        View more
      </div>
    </div>
  );
};

export default HomeProjects;
